import SectionBadge from "@/components/site/SectionBadge";

const GRID = "max-w-7xl mx-auto px-6 sm:px-8 md:px-12";

/**
 * Leadership impact cards — verified metrics only, with attribution note.
 * impact: [{ metric, body }]
 */
export default function ImpactStrip({
  testid,
  badge = "Selected Leadership Impact",
  headline,
  impact,
  note,
}) {
  return (
    <section data-testid={testid} className="py-16 md:py-20 bg-white">
      <div className={GRID}>
        <SectionBadge label={badge} />
        {headline && (
          <h2 className="font-serif-display text-3xl sm:text-4xl mt-6 leading-[1.1] max-w-3xl">
            {headline}
          </h2>
        )}
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 reveal stagger-reveal">
          {impact.map((im, i) => (
            <div
              key={i}
              data-testid={`${testid}-card-${i}`}
              className="bg-[#F2F2F2] border border-black/5 p-8 md:p-10"
            >
              <div className="font-serif-display text-3xl md:text-4xl text-black leading-tight">
                {im.metric}
              </div>
              <p className="mt-4 text-[15px] text-zinc-700 leading-relaxed">{im.body}</p>
            </div>
          ))}
        </div>
        {note && (
          <p className="mt-6 text-sm text-zinc-500 italic max-w-3xl">{note}</p>
        )}
      </div>
    </section>
  );
}
